import { ApiEnvironment } from '../../models/api-environment';
import { SectionName } from './models/section-name';

export class TripManagementSettingsEnvironment extends ApiEnvironment {
  configurationSectionNameUrl(sectionName?: SectionName) {
    return `${this.baseUrl}/api/v1/configuration/${sectionName ?? ''}`;
  }

  get configurationWeatherAlerts() {
    return `${this.baseUrl}/api/v1/configuration/weatherAlerts`;
  }

  override resolve(environment: unknown) {
    return environment instanceof TripManagementSettingsEnvironment
      ? environment
      : this;
  }
}

export const tripManagementSettingsEnvironment =
  new TripManagementSettingsEnvironment();
